export { default } from '@/features/pos/pages/OrderFinalizationPage'
